import '../pages/content'
import '../sass/content.scss'
import '../sass/content-advice.scss'
